import React from "react";
import styles from "./PartnerProgram.module.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useApi } from "../../hooks/useApi";
import { API_ENDPOINTS } from "../../api/endpoints";
import { PartnerProgramData } from "../../utils/dummyData";
import Loader from "../../components/Loader/Loader";
import ErrorMsg from "../../components/ErrorMsg/ErrorMsg";

export default function PartnerProgram() {
  const { response, loading, error } = useApi(
    API_ENDPOINTS.HOME_KNOWLEDGE_PARTNER_PROGRAM
  );
  const apiData = response?.knowledgePartnerProgram ?? [];
  const navigate = useNavigate();
  const [leftCard, ...rightCards] = apiData;

  return (
    <section className={styles.container}>
      <div className={styles.partnersProgram}>
        <h3>
          Knowledge <br /> <span>Partner Program</span>
        </h3>

        {loading ? (
          <Loader />
        ) : error ? (
          <ErrorMsg />
        ) : (
          <div className={styles.cards}>
            {/* Left Content */}
            <div className={styles.leftContent}>
              <article className={styles.card}>
                <h4>{leftCard.title}</h4>
                <p>{leftCard.short_desc}</p>
                <div className={styles.tagOuter}>
                  <ul className={styles.tagContainer}>
                    {/* {Array.isArray(leftCard.tags) &&
                      leftCard.tags.map((tag, i) => <li key={i}>{tag}</li>)} */}

                    {PartnerProgramData[0].tags.map((tag, i) => (
                      <li key={i}>{tag}</li>
                    ))}
                  </ul>
                  <button onClick={() => navigate(leftCard.link)}>
                    {leftCard.button_name}
                  </button>
                </div>
              </article>
            </div>

            {/* Right Content */}
            <div className={styles.rightContent}>
              {rightCards.slice(0, 2).map((item) => (
                <article className={styles.card} key={item.id}>
                  <h4>{item.title}</h4>
                  <p>{item.short_desc}</p>
                  <div className={styles.tagOuter}>
                    <ul className={styles.tagContainer}>
                      {/* {Array.isArray(item.tags) &&
                        item.tags.map((tag, i) => <li key={i}>{tag}</li>)} */}
                      {PartnerProgramData[0].tags.map((tag, i) => (
                        <li key={i}>{tag}</li>
                      ))}
                    </ul>

                    <button onClick={() => navigate("/institutions")}>
                      {item.button_name}
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        )}
        <Link className={styles.viewFullComparison} to="/institutions">
          View full comparison table
        </Link>
      </div>
    </section>
  );
}
